module.exports = __webpack_public_path__ + "img/gouwuchered.370f9299.svg";